import React from "react";
import {useHeader} from "../../_metronic/layout";
import {useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import {default as ProjectsPage} from "../modules/Projects/ProjectsPage";

export function Projects() {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: "projects-page-title",
    defaultMessage: "Projects"
  }));
  const subheader = useSubheader();
  subheader.setCustomClassName("subheader-custom-height");
  subheader.setDisplaySubheader(false);

  return <ProjectsPage/>;
}
